import store from "@/state/store";
import { notify } from '@kyvg/vue3-notification';
import router from "@/router";

export function getStatusVariant(status) {
  switch (status) {
    case 'new':
    case 'processing':
      return 'primary';
    case 'Pending':
    case 'pending':
    case 'Disputed':
    case 'pending_payment':
      return 'warning';
    case 'Partialy Paid':
      return 'info';
    case 'Paid':
    case 'completed':
    case 'success':
    case 'Verified':
    case 'publish':
    case 1:
    case 'dispatched':
      return 'success';
    case 'Cancelled':
    case 'refunded':
    case 'failed':
    case 'return':
    case 'Not verified':
    case 0:
      return 'danger';
    default:
      return 'secondary';
  }
}

export function getStatusPriceColor(amount) {
  if (amount > 0) {
    return 'success'; // For positive values, return 'success'
  } else if (amount < 0) {
    return 'danger'; // For negative values, return 'danger'
  } else {
    return 'secondary'; // For zero or neutral values, return 'secondary'
  }
}

export function getStatusIcon(status) {
    switch (status) {
      case 'pending':
        return 'bx bx-hourglass';
      case 'partialy_paid':
        return 'bx bx-wallet';
      case 'paid':
        return 'bx bx-check-circle';
      case 'cancelled':
        return 'bx bx-x-circle';
      default:
        return 'bx bx-message-square-dots';
    }
}

export function getBillStatusOptions(){
    return [
      { value: 'pending', text: 'Pending' },
      { value: 'partialy_paid', text: 'Partialy Paid' },
      { value: 'paid', text: 'Paid' },
      { value: 'cancelled', text: 'Cancelled' },
    ];
}

export function formatCurrency(amount, currencyLabelFirst = false) {
  if(amount == 0 || !amount) return amount;
  const currency = store.state.authApi.currency;
  // Ensure the amount is formatted correctly with the currency
  return currencyLabelFirst ? `${currency} ${amount}` : `${amount} ${currency}`;  // Fallback to active currency if missing
}

export function setDateRangeFromURL() {
  // Extract the URL parameters
  const url = new URL(window.location.href);
  const startDate = url.searchParams.get("start_date");
  const endDate = url.searchParams.get("end_date");

  // Format and set the date range
  if (startDate && endDate) {
    const formattedStartDate = startDate.split(" ")[0]; // Extract the date part
    const formattedEndDate = endDate.split(" ")[0]; // Extract the date part
    return  `${formattedStartDate} to ${formattedEndDate}`;
  }

  return [];
}

export function copyTextName(fileName) {
  // Copy the file name to clipboard
  navigator.clipboard.writeText(fileName).then(() => {
    notify({
      type: 'success',
      title: 'Success',
      text: fileName +' copy successfully',
    });
  }).catch((err) => {
    console.error("Failed to copy text: ", err);
  });
}

export function redirectToRoute(path) {
  router.push(path);
}
